import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzEaster65 } from './pages'

type TIdToPageMapWoofzLove = Record<PageIdWoofzEaster65, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_EASTER_65: TIdToPageMapWoofzLove = {
  [PageId.SUBSCRIPTIONS_EASTER_65]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_easter/woofz_easter_65/pages/subscriptions/SubscriptionEaster65'
      ).then((m) => ({
        default: m.SubscriptionsEaster65,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_easter/woofz_easter_65/pages/subscriptions/SubscriptionEaster65'
      ),
  },
  [PageId.CHAT_UPSELL_EASTER_65]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_easter/woofz_easter_65/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_easter/woofz_easter_65/pages/upsell/ChatUpsellNewFlow'
      ),
  },
  [PageId.UPSELL_EASTER_65]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_easter/woofz_easter_65/pages/upsell/Upsell'
      ).then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_easter/woofz_easter_65/pages/upsell/Upsell'),
  },
  [PageIdWoofzEaster65.DOWNLOAD_EASTER_65]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_easter/woofz_easter_65/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_easter/woofz_easter_65/pages/download-app/DownloadApp'
      ),
  },
  [PageIdWoofzEaster65.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
